import EditWorkingDays from './EditWorkingDays.component';

export default EditWorkingDays;
